<template>
  <Modal
  v-model="isShow"
  :width="400"
  :loading="loading"
  :mask-closable="false"
  @on-ok="ok"
  >
		<h3 slot="header" class="modal-header">答谢队友</h3>
		<Row class="mb16 page-wrapper" :gutter="16">
		<Col span="23">
			<Select v-model="zoFid" placeholder="请选择要答谢的队友" @on-change="getZoName">
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in zoList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
			</Select>
		</Col>
		</Row>
		<Slider style="width:340px" class="page-wrapper" :value.sync="score1" show-stops :max="max" @on-change="getScore"></Slider>
	</Modal>
</template>

<script>

import {dealWorkOrder,getProjectZos} from 'api/workOrder'
import {
 getName, getEmpCode
} from "@/utils/auth";
export default {
	props:{
		d:{
			type: Number,
      default: 0
		},
		projectFid:{
			type:String,
			default:''
		},
		score:{
			type:Number,
			default:0
		},
		workOrderFid:{
			type:String,
			default: ''
		}
	},
	data(){
		return{
			max:10,
			score1:0,
			zoList:[],
			zoFid:'',
			loading:true,
			isShow:false,
			zoName:'',
		}
	},
	watch:{
		d(){
			this.score1 = 0;
			this.zoFid = ''
			this.zoName = ''
			this.isShow = true
      this.max = this.score;
			let empCode = this.$store.getters.empCode
			this.zoList = []
			getProjectZos({
				projectFid:this.projectFid
			})
			.then( res => {
        const zoList = res.data;
        zoList.forEach((ele,index)=>{
          if(ele.isProjectManager == 0){
            this.zoList.push(ele)
          }
        })
        this.zoList.forEach((item,index)=>{
          if(item.value == empCode){
            this.zoList.splice(index,1)
          }
        })
			})
		}
  },
	methods:{
		getZoName(value){
			this.zoList.forEach( ele=>{
				if(ele.value === this.zoFid){
					this.zoName = ele.text
				}
			})
		},
		getScore(value){
			this.score1 = value;
		},
		ok(){
			if(this.score1 != 0 && !this.zoFid){
				this.$Message.info('请选择要答谢的管家')
				this.changeLoading();
				return false
			}
			const params = {
				zoFid:this.zoFid,
				score:this.score1,
				workOrderFid:this.workOrderFid,
				zoName:this.zoName
			}
			dealWorkOrder(params)
			.then( res => {
				if(res.code === 0){
					this.$Message.success('办结成功')
					this.$emit('done')
				} 
			})
			// .catch( error => {
			// 	this.$Message.error('办结失败')
			// })
			.finally(()=>{
				this.isShow = false
			})
		},
		changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
	}
}
</script>

<style>

</style>